import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/images/amenity-icon.svg'
import _imports_1 from '../assets/images/EHO-LOGO.svg'


const _hoisted_1 = {
  id: "footer",
  class: "embfooter"
}
const _hoisted_2 = {
  "aria-label": "mobile legends",
  class: "mobile-legends"
}
const _hoisted_3 = { class: "embfooter__status" }
const _hoisted_4 = {
  key: 0,
  class: "embfooter__status__list",
  style: {"color":"rgba(146, 159, 0, 1)"}
}
const _hoisted_5 = { class: "emb-card_body" }
const _hoisted_6 = { class: "embfooter__status" }
const _hoisted_7 = {
  key: 0,
  class: "embfooter__status__list",
  style: {"color":"rgba(146, 159, 0, 1)"}
}
const _hoisted_8 = { class: "embfooter__disclaimer" }

import { ref, onMounted, nextTick, computed, toRefs, onUpdated } from "vue";
import StackIcon from "@/assets/icons/StackIcon.vue";
import { apiMessages } from "./../api/message-api";
import { Status, OrderFooter } from "@/constant";
import type {
  Amenity,
  CommunityQmiDetails,
  ComparedSvgFooterData,
  FooterData,
  LotCountNeighborhood,
} from "../types";

interface Props {
  open: boolean;
  selectedNeighborhoodIds: string[];
  data: FooterData[];
  amenities: Amenity[];
  lotsCount: LotCountNeighborhood[];
  futureHomePlans: CommunityQmiDetails;
  matchedSvgfooterData: ComparedSvgFooterData[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppFooter',
  props: {
    open: { type: Boolean },
    selectedNeighborhoodIds: {},
    data: {},
    amenities: {},
    lotsCount: {},
    futureHomePlans: {},
    matchedSvgfooterData: {}
  },
  emits: [
  "toggleFooter",
  "setLegends",
  "recalculateSidebarHeight",
],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const {
  open,
  selectedNeighborhoodIds,
  data,
  amenities,
  lotsCount,
  futureHomePlans,
  matchedSvgfooterData,
} = toRefs(props);

const emit = __emit;

const messages = ref<any>({});
const height = ref(0);

const loadMessages = async () => {
  const { messages: apiMsg } = await apiMessages("AppFooter");
  messages.value = apiMsg;
};

const updateFooter = () => emit("toggleFooter");

const changeFooterHeight = () => {
  const legendDiv = document.getElementsByClassName("embfooter-card")[0];
  if (!legendDiv) return;

  const resizeObserver = new ResizeObserver(() => {
    height.value = (legendDiv as any).offsetHeight;
    document.documentElement.style.setProperty(
      "--footerLegendHeight",
      `${height.value}px`
    );
  });
  resizeObserver.observe(legendDiv);
};

const isPresentLotWithStatus = (status: string) => {
  const lotType = status.toLowerCase().replace(" ", "").replace("-", "");
  if (selectedNeighborhoodIds.value.length) {
    return lotsCount.value.find(
      (neighborhoodLot) =>
        neighborhoodLot.neighborhoodId === selectedNeighborhoodIds.value[0]
    )?.[lotType];
  } else {
    return lotsCount.value.find(
      (neighborhoodLot) => neighborhoodLot?.[lotType]
    )?.[lotType];
  }
};

const sortFooter = (updateFooterData: FooterData[]) => {
  const sortedFooterData: FooterData[] = [];
  for (const order of OrderFooter) {
    const found = updateFooterData.find((el) => el.status === order);
    if (found) sortedFooterData.push(found);
  }
  return sortedFooterData;
};
const updateFooterAsSvgData = (footerData: FooterData[]) => {
  footerData.forEach((data, index) => {
    const matchedData = matchedSvgfooterData.value.filter((d) =>
      d.status.includes(data.status.toLowerCase())
    );
    const updateNeighborhoods = matchedData.map((d) => d.neighborhood_code);
    if (!updateNeighborhoods.length) {
      footerData.splice(index, 1);
    } else {
      data.neighborhoods = updateNeighborhoods;
    }
  });
};

const footerFutureHomePlan = (footerData: FooterData[]) => {
  if (
    (!selectedNeighborhoodIds.value.length &&
      Object.keys(futureHomePlans.value).length) ||
    Object.keys(futureHomePlans.value).includes(
      selectedNeighborhoodIds.value[0]
    )
  ) {
    footerData.push({
      color: "#CBBE98",
      neighborhoods: [...Object.keys(futureHomePlans.value)],
      status: Status.FUTURE_HOME,
    });
  }
  updateFooterAsSvgData(footerData);
};

const footerData = computed(() => {
  let futureHomeFooterData =
    data.value.filter((item) => isPresentLotWithStatus(item.status)) || [];
  footerFutureHomePlan(futureHomeFooterData);
  futureHomeFooterData = sortFooter(futureHomeFooterData);

  if (selectedNeighborhoodIds.value.length) {
    futureHomeFooterData = futureHomeFooterData.filter((d) =>
      d.neighborhoods.includes(selectedNeighborhoodIds.value[0])
    );
  }

  const legendArr = futureHomeFooterData.map((plan) => plan.status).toString();
  emit("setLegends", legendArr);
  return futureHomeFooterData;
});

onMounted(() => {
  loadMessages();
  nextTick(() => changeFooterHeight());
});

const recalculateSidebarHeight = () => emit("recalculateSidebarHeight");

onUpdated(() => recalculateSidebarHeight());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", {
      onClick: updateFooter,
      class: _normalizeClass(['emb_collapsedicon dsize', { show: !_unref(open) }])
    }, [
      _createVNode(StackIcon, {
        class: "stack-icon",
        width: "36px",
        height: "36px"
      }),
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "mobile-legends-title" }, "Legend", -1)),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerData.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "embfooter__status__list",
              key: item.status,
              style: _normalizeStyle({ color: item.color })
            }, [
              _createElementVNode("span", {
                class: "dsize",
                style: _normalizeStyle({ backgroundColor: item.color, color: item.color })
              }, null, 4)
            ], 4))
          }), 128)),
          (_unref(amenities)?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("img", {
                  class: "ammenity-icon",
                  src: _imports_0,
                  alt: ""
                }, null, -1)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(['embfooter-card', { 'fade-out': !_unref(open) }])
    }, [
      _createElementVNode("i", {
        "aria-label": "close icon",
        class: "emb_closeicon is-gray",
        onClick: updateFooter
      }),
      _createElementVNode("div", _hoisted_5, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "embfooter__ehologo" }, [
          _createElementVNode("img", {
            src: _imports_1,
            class: "embfooter_ehosvg"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerData.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "embfooter__status__list",
              key: item.status,
              style: _normalizeStyle({ color: item.color })
            }, [
              _createElementVNode("span", {
                class: "dsize",
                style: _normalizeStyle({ backgroundColor: item.color, color: item.color })
              }, null, 4),
              _createTextVNode(" " + _toDisplayString(item.status), 1)
            ], 4))
          }), 128)),
          (_unref(amenities)?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("img", {
                  class: "ammenity-icon",
                  src: _imports_0,
                  alt: ""
                }, null, -1),
                _createTextVNode(" Amenity ", -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", _hoisted_8, _toDisplayString(messages.value.disclaimer), 1)
      ])
    ], 2)
  ]))
}
}

})